import React from 'react';
import config from '../config';
import PageHeader from '../components/PageHeader';
import Container from '../components/Container';
import TheTreasurePage from '../components/TheTreasurePage';
import { NextSeo } from 'next-seo';

function RafflesPage() {
  const description = `Open your Shitty Treasure Boxes and claim your rewards.`;

  return (
    <>
      <NextSeo title={`Shitty Treasure Boxes - ${config.siteName}`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Shitty Treasure Boxes'}
          description={description}
          docsLink='https://docs.shittykitties.art/website-utilities/shitty-treasure-boxes'
        />
        <Container>
          <TheTreasurePage />
        </Container>
      </div>
    </>
  );
}

export default RafflesPage;
